import { VozidloPujcovna } from './vozidloPujcovna';
import { Zapujcky } from './zapujcka';
import { PlanovanaPujcka } from './planovanaPujcka';
import { PredmetPujcovna } from './ostatniPredmety';

export const menu = {
	name: 'APUJ_Pujcovna',
	orderAlphabetically: false,
	list: [
		{ name: 'Zapujcka', route: Zapujcky.name },
		{ name: 'PlanovanaPujcka', route: PlanovanaPujcka.name },
		{ name: 'APUJ_Vozidla', route: VozidloPujcovna.name },
		{ name: 'APUJ_OstatniPredmety', route: PredmetPujcovna.name },
	],
};
